export const CONNECT_WALLET = 'CONNECT_WALLET';
export const RESET_WALLET_STATE = 'RESET_WALLET_STATE';
